import React, { lazy, Suspense, useEffect } from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import TableSkeleton from '../../../components/TableSkeleton';
import Spinner from '../../../components/Spinner';
import { useExtHistory } from '../../../contexts/extractions/ExtHistoryContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { PlusIcon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

const TanstackTable = lazy(() => import('../../../components/TanstackTable'));
const ConfirmDialog = lazy(() => import('../../../components/ConfirmDialog'));

const Manage = () => {
    const navigate = useNavigate();
    const {
        table,
        columns,
        loading,
        extractions,
        pagination,
        handlePageChange,
        updateData,
        setOpenUpdateModal,
        showDeleteConfirmationDialog,
        handleCloseModal,
        handleDelete,
        searchKeyword,
        handleSearch,
        handleClearSearch,
    } = useExtHistory();

    useEffect(() => {
        if (updateData.id !== "") {
            setOpenUpdateModal(true);
        }
    }, [updateData, setOpenUpdateModal]);

    return (
        <>
            <div className="flex justify-end mb-4">
                <Button variant="border_outline" onClick={() => navigate("/extraction/new")}>
                    <PlusIcon className="h-4 w-4 mr-2" />
                    New Extraction
                </Button>
            </div>
            <Card className="w-full mb-2 overflow-hidden">
                <CardHeader>Extractions</CardHeader>
                <CardContent>
                    {/* Search Bar */}
                    <div className="flex items-center gap-2 mb-4">
                        <div className="relative w-full max-w-sm">
                            <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
                            <input
                                type="text"
                                value={searchKeyword}
                                onChange={handleSearch}
                                placeholder="Search extractions..."
                                className="w-full pl-9 pr-8 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent bg-white"
                            />
                            {searchKeyword && (
                                <button
                                    onClick={handleClearSearch}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                >
                                    <XMarkIcon className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                    </div>

                    <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Status", "Actions"]}/>}> 
                        <TanstackTable
                            loading={loading}
                            table={table}
                            data={extractions || []}
                            columns={columns}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                        />
                    </Suspense>
                </CardContent>
            </Card>
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Extraction?"
                />
            </Suspense>
        </>
    );
};

export default Manage;